(function($) {

    // Slider nav
    $('.slider-nav .tabbed-link').on('click', function() {

        $this = $(this);
        var tabbedPanelID = '#' + $this.data('target');
        var tabbedPanel = $('.tabbed-block');

        // Adds active class to current menu item
        $('.slider-nav .tabbed-link').removeClass('is-active')
        $this.addClass('is-active');

        // Adds active class to tabbed panel
        $('.tabbed-panel').fadeOut(800).removeClass('is-active');
        $(tabbedPanel).find(tabbedPanelID).fadeIn(800).addClass('is-active');

    });

    $this = $(this);
    var tabbedPanelID = '#' + $this.data('target');
    var tabbedPanel = $('.tabbed-block');


}(jQuery));


(function($) {

    var navComponent = $('.sticky-nav');
    var scrollingPanel = $('.scrolling-panel');
    var siteHeaderHeight = $('.site-header .navbar-primary').outerHeight();
    var siteContent = $('.site-content').outerHeight();

    // Check for tabbed nav component
    if (navComponent.length) {

        if ($(window).width() > 992) {
            var top = navComponent.offset().top - 58;
        } else {
            var top = navComponent.offset().top - siteHeaderHeight;
        }

        $(window).scroll(function (event) {
            var y = $(this).scrollTop();

            if (y >= top) {
                navComponent.addClass('is-fixed');
                $(siteContent).css('padding-top', siteHeaderHeight + 'px');
            }
            else {
                navComponent.removeClass('is-fixed');
                $(siteContent).css('padding-top', 0);
            }
        });
    }

    // Check for scrolling panel
    if (scrollingPanel.length) {
        var ppWaypoint = $('.scrolling-panel').waypoint(function(direction) {

            // check the direction
            if((direction == 'down') || (direction == 'up')) {

                $this = $(this.element);

                var scrollingPanelID = $this.data('id');

                //$this.addClass('is-top');

                // $('.tabbed-nav .slider-nav')
                //     .find("a[href$='" + scrollingPanelID + "']")
                //     .addClass('is-active');

                $(".slider-nav").slick('slickGoTo', scrollingPanelID, true);

                this.destroy();

            }
        }, {
            offset: '240px'
        });
    }

}(jQuery));